/* MBD Marketplace — core: utils, toast, cart, header, drawers, search */
(function () {
  'use strict';
  var M = window.MBD = window.MBD || {};
  M.routes = M.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  M.$ = $; M.$$ = $$;
  M.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || M.moneyFormat || '{{amount_no_decimals_with_comma_separator}}₫';
    function fmt(n, p, t, d) { t = t || ','; d = d || '.'; var parts = (n / 100).toFixed(p).split('.'); return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : ''); }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/), v;
    switch (m ? m[1] : '') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 0, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  };
  M.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  M.debounce = function (fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; };
  M.store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  M.root = function () { return (M.routes.root || '/').replace(/\/$/, ''); };

  var toastTimer;
  M.toast = function (msg, type, html) {
    var wrap = $('.mbd-toast-wrap');
    if (!wrap) { wrap = document.createElement('div'); wrap.className = 'mbd-toast-wrap mbd-scope'; wrap.setAttribute('aria-live', 'polite'); document.body.appendChild(wrap); }
    var path = type === 'error' ? '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>' : '<path d="M20 6 9 17l-5-5"/>';
    wrap.innerHTML = '<div class="mbd-toast' + (type === 'error' ? ' is-error' : '') + '" role="status"><svg class="mbd-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' + path + '</svg><div>' + M.esc(msg) + '</div>' + (html || '') + '</div>';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { wrap.innerHTML = ''; }, 2400);
  };

  M.setCartCount = function (n) { $$('[data-mbd-cart-count]').forEach(function (el) { el.textContent = n > 99 ? '99+' : n; el.hidden = !(n > 0); }); };
  M.refreshCart = function () { return fetch(M.root() + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { M.setCartCount(c.item_count); return c; }); };
  M.addToCart = function (id, qty) {
    return fetch(M.root() + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) { M.refreshCart(); document.dispatchEvent(new CustomEvent('mbd:cart:added', { detail: d })); return d; });
  };
  M.cartError = function (err) { M.toast((err && (err.description || err.message)) || 'Không thể thêm vào giỏ hàng, vui lòng thử lại.', 'error'); };
  M.addedToast = function () { M.toast('Đã thêm vào giỏ hàng', 'ok', '<a href="' + (M.routes.cart || '/cart') + '">Xem giỏ hàng</a>'); };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mbd-add]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    M.addToCart(btn.getAttribute('data-mbd-add'), 1).then(M.addedToast).catch(M.cartError).finally(function () { btn.classList.remove('is-loading'); });
  });
  M.markLoaded = function (scope) { $$('.mbd-media img', scope).forEach(function (img) { if (img.complete) img.parentNode.classList.add('is-loaded'); else img.addEventListener('error', function () { img.parentNode.classList.add('is-loaded'); }); }); };

  M.initHeader = function () {
    var wrap = $('[data-mbd-header]');
    if (!wrap) return;
    var setH = function () { document.documentElement.style.setProperty('--header-h', wrap.offsetHeight + 'px'); };
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(wrap);
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { wrap.classList.toggle('is-scrolled', window.scrollY > 60); ticking = false; });
    }, { passive: true });
  };

  function openDrawer(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('mbd-lock'); }
  M.closeDrawers = function () { $$('.mbd-drawer.is-open, .mbd-plp__sidebar.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }); document.body.classList.remove('mbd-lock'); };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mbd-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(document.getElementById(o.getAttribute('data-mbd-drawer-open'))); return; }
    if (e.target.closest('[data-mbd-drawer-close]')) { e.preventDefault(); M.closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') M.closeDrawers(); });

  var HKEY = 'mbd_search_history';
  var IC_HIST = '<svg class="mbd-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>';
  var IC_SEARCH = '<svg class="mbd-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>';
  function hl(text, q) { var i = text.toLowerCase().indexOf(q.toLowerCase()); if (!q || i < 0) return M.esc(text); return M.esc(text.slice(0, i)) + '<mark>' + M.esc(text.slice(i, i + q.length)) + '</mark>' + M.esc(text.slice(i + q.length)); }
  M.searchUrl = function (q) { return (M.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; };
  function saveHistory(q) { q = (q || '').trim(); if (!q) return; var h = M.store.get(HKEY, []).filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); h.unshift(q); M.store.set(HKEY, h.slice(0, 8)); }
  M.initSearch = function (box) {
    if (box.__mbd) return; box.__mbd = 1;
    var input = $('[data-mbd-search-input]', box), panel = $('[data-mbd-search-panel]', box), form = $('form', box);
    var popular = (box.getAttribute('data-popular') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var ctrl, lastQ = '';
    function idle() {
      var h = M.store.get(HKEY, []), html = '';
      if (h.length) {
        html += '<div class="mbd-sp__group"><div class="mbd-sp__head">Lịch sử tìm kiếm<button type="button" data-clear>Xóa</button></div>';
        h.forEach(function (q) { html += '<a class="mbd-sp__item" href="' + M.searchUrl(q) + '" data-q="' + M.esc(q) + '">' + IC_HIST + M.esc(q) + '</a>'; });
        html += '</div>';
      }
      if (popular.length) {
        html += '<div class="mbd-sp__group"><div class="mbd-sp__head">Từ khóa phổ biến</div><div class="mbd-sp__pop">';
        popular.forEach(function (q) { html += '<a class="mbd-chip" href="' + M.searchUrl(q) + '" data-q="' + M.esc(q) + '">' + M.esc(q) + '</a>'; });
        html += '</div></div>';
      }
      return html;
    }
    function show(html) { if (!html) { panel.hidden = true; return; } panel.innerHTML = html; panel.hidden = false; }
    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {}, html = '';
      var qs = r.queries || [], cs = r.collections || [], ps = r.products || [];
      if (qs.length) { html += '<div class="mbd-sp__group">'; qs.slice(0, 5).forEach(function (x) { html += '<a class="mbd-sp__item" href="' + M.searchUrl(x.text) + '" data-q="' + M.esc(x.text) + '">' + IC_SEARCH + '<span>' + hl(x.text, q) + '</span></a>'; }); html += '</div>'; }
      if (cs.length) { html += '<div class="mbd-sp__group"><div class="mbd-sp__head">Danh mục</div>'; cs.slice(0, 3).forEach(function (c) { html += '<a class="mbd-sp__item" href="' + c.url + '">' + hl(c.title, q) + '</a>'; }); html += '</div>'; }
      if (ps.length) {
        html += '<div class="mbd-sp__group"><div class="mbd-sp__head">Sản phẩm</div>';
        ps.slice(0, 6).forEach(function (p) {
          var u = p.featured_image && p.featured_image.url, img = u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=100' : '';
          html += '<a class="mbd-sp__item mbd-sp__prod" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" width="44" height="44" loading="lazy">' : '') + '<span class="mbd-sp__prod-title">' + hl(p.title, q) + '</span><span class="mbd-sp__prod-price">' + M.formatMoney(Math.round(Number(p.price) * 100)) + '</span></a>';
        });
        html += '</div>';
      }
      if (!html) html = '<div class="mbd-sp__empty">Không có gợi ý cho “' + M.esc(q) + '”. Nhấn Enter để tìm kiếm.</div>';
      html += '<a class="mbd-sp__all" href="' + M.searchUrl(q) + '" data-q="' + M.esc(q) + '">Xem tất cả kết quả cho “' + M.esc(q) + '”</a>';
      show(html);
    }
    var suggest = M.debounce(function (q) {
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      fetch(M.root() + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); }).then(function (d) { if (q === lastQ) render(q, d); }).catch(function () {});
    }, 180);
    input.addEventListener('focus', function () { var q = input.value.trim(); lastQ = q; if (!q) show(idle()); else suggest(q); });
    input.addEventListener('input', function () { var q = input.value.trim(); lastQ = q; if (!q) { show(idle()); return; } suggest(q); });
    input.addEventListener('keydown', function (e) {
      var items = $$('.mbd-sp__item, .mbd-sp__all', panel), cur = $('.is-focus', panel), i = items.indexOf(cur);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (!items.length) return;
        if (cur) cur.classList.remove('is-focus');
        i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i - 1 + items.length) % items.length;
        items[i].classList.add('is-focus'); items[i].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && cur) { e.preventDefault(); cur.click(); }
      else if (e.key === 'Escape') { panel.hidden = true; input.blur(); }
    });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-clear]')) { e.preventDefault(); M.store.set(HKEY, []); show(idle()); input.focus(); return; }
      var a = e.target.closest('[data-q]'); if (a) saveHistory(a.getAttribute('data-q'));
    });
    form.addEventListener('submit', function (e) { var q = input.value.trim(); if (!q) { e.preventDefault(); input.focus(); return; } saveHistory(q); });
    document.addEventListener('click', function (e) { if (!box.contains(e.target) && !box.closest('#mbd-search-overlay')) panel.hidden = true; });
  };
  M.initSearchOverlay = function () {
    var ov = $('#mbd-search-overlay');
    if (!ov) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mbd-search-open]')) { e.preventDefault(); ov.hidden = false; document.body.classList.add('mbd-lock'); var i = $('[data-mbd-search-input]', ov); i.focus(); }
      else if (e.target.closest('[data-mbd-search-close]')) { e.preventDefault(); ov.hidden = true; document.body.classList.remove('mbd-lock'); }
    });
  };
})();